//Please add the language resource
const printShipOrder = {

  msg:{
  }
};
export default printShipOrder



// WEBPACK FOOTER //
// ./src/page/yard/recovery/lang/recovery.en.js